import React from 'react';
import { Layout, Menu, Dropdown, Avatar } from 'antd';
import { connect } from 'react-redux';
import Text from 'antd/lib/typography/Text';
import { FontAwesomeIcon as FAI } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons/faBars';
import { faUser } from '@fortawesome/free-solid-svg-icons/faUser';
import { isMobile, MobileView } from 'react-device-detect';
import { get_user_avatar, goToEasebuzz } from '../../../app_methods';
import './index.scss';
import { updateCurrentUserAction } from '../../../redux/actions';

const Navbar = (props) => {
    const { Header } = Layout;
    return (
        <Header className="lobo-navbar lobo-bg-white d-flex justify-content-between align-items-center" style={{ ...styles.header, paddingLeft: props.sidebarCollapsed ? 0 : 255 }}>
            <div>
                <MobileView>
                    <FAI icon={faBars} size="2x" className="c-pointer ml-2 sidebar-trigger" onClick={props.toggleSidebar.bind(this)} />
                </MobileView>
            </div>
            <div>
                <Dropdown trigger={['click']} placement="bottomLeft" overlay={false ? <></> : (

                    <Menu>
                        <Menu.Item onClick={() => goToEasebuzz('merchant/profile')}>
                            <FAI icon={faUser} color="grey" /><span className="ml-2">Profile</span>
                        </Menu.Item>
                    </Menu>
                )}>
                    <span className={`c-pointer user-avatar-name ant-dropdown-link pr-2 pl-2 align-items-center ${!props.sidebarCollapsed && isMobile ? 'd-none' : 'd-flex'}`} href="#" style={{ minWidth: 120, display: 'block' }}>
                        <Avatar src={get_user_avatar(props.current_user)} icon="user" className="mr-2" />
                        <Text strong>{props.current_user.name}</Text>
                    </span>
                </Dropdown>
            </div>
        </Header>
    )
}

const styles = {
    header: {
        background: '#eee',
        padding: 0,
        height: "48px",
        lineHeight: "48px",
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9,
        transition: 'all .2s',
        WebkitTransition: 'all .2s'
    }
}

const mapStateToProps = state => ({
    current_user: state.userReducer.current_user
})

const mapDispatchToProps = dispatch => ({
    updateCurrentUser: user => dispatch(updateCurrentUserAction(user))
})

export default connect(mapStateToProps, mapDispatchToProps)(Navbar);